export enum PERMISSION_KEY {
    BRAND_SUPER_ADMIN = 'brand_super_admin',
    EDITOR = 'editor',
    ORDER_MANAGEMENT = 'order_management',
    PRODUCT_MANAGEMENT = 'product_management',
    MEMBER_MANAGEMENT = 'member_management',
    PROMO_MANAGEMENT = 'promo_management',
    SHIPPING_MANAGEMENT = 'shipping_management',
    REFUND_MANAGEMENT = 'refund_management',
    FINANCE_MANAGEMENT = 'finance_management',
}
